import { ComponentDocs } from "components/docs";
import { ComponentExample } from "components/examples";
import { ExternalProps } from "constants/external";

const FormDateTime = () => (
  <ComponentDocs
    name="<Form.DateTime/>"
    entry="DateTime"
    propsEntry="DateTimeProps"
    namespace="FormFields"
    externalProps={ExternalProps.MuiDateTimePicker}
  >
    <ComponentExample
      name="Local date/time"
      description="A local date/time represents a point in time that is local to the user's timezone."
      import={import("examples/Forms/FormDateTime/LocalDateTimeExample")}
      rawImport={import("examples/Forms/FormDateTime/LocalDateTimeExample?raw")}
    />
    <ComponentExample
      name="Instant date/time"
      description="An instant date/time represents a point in time that can be globally agreed on, in the form of an ISO8601 UTC string."
      import={import("examples/Forms/FormDateTime/InstantDateTimeExample")}
      rawImport={import(
        "examples/Forms/FormDateTime/InstantDateTimeExample?raw"
      )}
    />
    <ComponentExample
      name="Restricted date/times"
      import={import("examples/Forms/FormDateTime/RestrictedDateTimesExample")}
      rawImport={import(
        "examples/Forms/FormDateTime/RestrictedDateTimesExample?raw"
      )}
    />
  </ComponentDocs>
);

export default FormDateTime;
